module.exports = __webpack_public_path__ + "img/hex_representation.0edb87e2.png";